// 文本消息内容
export interface ITextPayload {
    text: string;
}

interface ImageObj {
    width: number;
    height: number;
    size: number;
    url: string;
    type: number; // 0-原图; 1-198p压缩图; 2-720p压缩图
}

export interface IImagePayload {
    uuid: string;
    imageFormat: Number; // 图片格式类型，JPG/JPEG = 1，GIF = 2，PNG = 3，BMP = 4，其他 = 255
    imageInfoArray: ImageObj[];
    cloudCustomData?: string;
}

export interface IAudioPayload {
    uuid: string;
    url: string;
    size: number;
    second: number;
}

export interface IVideoPayload {
    videoFormat: number;
    videoSecond: number;
    videoSize: number;
    videoUrl: string;
    videoUuid: string;
    thumbWidth: number;
    snapshotWidth: number;
    thumbHeight: number;
    snapshotHeight: number;
    thumbUrl: string;
    snapshotUrl: string;
}

export interface IFilePayload {
    // uuid: string;
    // fileName: string;
    // fileSize: number;
    // fileUrl: string;
    file: File;
}

export interface ICustomPayload {
    data: string;
    description: ICustomPayloadDescription | string;
    extension?: string;
}

export enum ICustomPayloadDescription {
    // 房间内部命令
    ChannelCommand = "ChannelCommand",
    // 单聊引用某条消息
    ChatReference = "ChatReference",
    // 房间内部互动
    ChannelInteraction = "ChannelInteraction",
    // 链接
    Link = "Link",
    // 亲密关系
    IntimateRelation = "IntimateRelation",
}

export interface IFacePayload {
    index: number;
    data: string;
}

export type PeerMsgType =
    | ITextPayload
    | IImagePayload
    | IAudioPayload
    | IVideoPayload
    | IFilePayload
    | ICustomPayload
    | IFacePayload;

// 发送消息类型
export enum CustomType {
    Text = "text",
    Custom = "custom",
    Image = "image",
    Face = "face",
    Audio = "audio",
    Video = "video",
    File = "file",
}

// SDK中消息的类型
export enum SDKMsgType {
    MSG_TEXT = "TIMTextElem",
    MSG_IMAGE = "TIMImageElem",
    MSG_AUDIO = "TIMSoundElem",
    MSG_VIDEO = "TIMVideoFileElem",
    MSG_FACE = "TIMFaceElem",
    MSG_FILE = "TIMFileElem",
    MSG_CUSTOM = "TIMCustomElem",
}

export interface ApplicationItemProps {
    id: number;
    senderId: string;
    receiverId: string;
    status: number;
    sendTime: string;
    handleTime: string;
    notified: number;
    senderNickname: string;
    receiverNickname: string;
    senderLogo: string;
    receiverLogo: string;
}
export interface ApplicationProps {
    sentRequests: ApplicationItemProps[];
    receivedRequests: ApplicationItemProps[];
    unreadCount: number;
}

interface UserInfo {
    userID: string;
    userName: string;
    avatar: string;
}

export interface IntimateItems {
    action: string;
    from: UserInfo;
    id: number;
    msgId: string;
    to: UserInfo;
    time: string;
    status: string; // "process" | "accept" | "refused" | "expire";
    relationship: string;
}

export interface IntimateProps {
    receiveList: IntimateItems[];
    sendList: IntimateItems[];
    unreadCount: number;
}

export interface ConversationProps {
    conversationList: any[];
    isSyncCompleted: boolean;
}

export interface UpdateConversationOptions {
    userID: string;
    nick?: string;
    avatar?: string;
    msgRemindType?: string;
    isPinned?: boolean;
}

export interface AddFriendProps {
    to: string;
    source: string;
    remark: string;
    groupName: string;
    wording: string;
}

export interface FriendGroupProps {
    name: string;
    count: number;
    userIDList: string[];
}

export interface UserStatusProps {
    userID: string;
    statusType: string;
    customStatus?: string;
}

export interface MessageProps {
    isCompleted: boolean;
    messageList: any[]; // 消息列表 Message[]
    nextReqMessageID: string;
}
